// Default lip-sync configuration (from lipsync-config.json preset).
// The controller combines audio bands, RMS volume, text cues and facial bones.

export const defaultLipSyncConfig = {
  bands: {
    low: {
      startBin: 2,
      endBin: 10,
      label: "Graves (Jaw/Mandíbula)"
    },
    mid: {
      startBin: 10,
      endBin: 30,
      label: "Médias (Vogais)"
    },
    high: {
      startBin: 30,
      endBin: 60,
      label: "Agudas (Consoantes)"
    }
  },
  morphTargets: {
    jawOpen: {
      volume: 0.33,
      low: 0.13,
      mid: 0.37,
      high: 0.49,
      text: 0.73,
      max: 1,
      lerp: 0.5
    },
    mouthClose: {
      volume: 0.04,
      low: 0.09,
      mid: 0.16,
      high: 0.09,
      text: 0.25,
      max: 0.34,
      lerp: 0.2
    },
    mouthFunnel: {
      volume: 0.04,
      low: 0.07,
      mid: 0.2,
      high: 0.33,
      text: 0.3,
      max: 0.51,
      lerp: 0.42
    },
    mouthPucker: {
      volume: 0.03,
      low: 0.05,
      mid: 0,
      high: 0,
      text: 0.28,
      max: 0.15,
      lerp: 0.1
    },
    mouthSmile_L: {
      volume: 0,
      low: 0,
      mid: 0.12,
      high: 0.03,
      text: 0,
      max: 0.25,
      lerp: 0.1
    },
    mouthSmile_R: {
      volume: 0,
      low: 0,
      mid: 0.12,
      high: 0.03,
      text: 0,
      max: 0.25,
      lerp: 0.1
    },
    mouthFrown_L: {
      volume: 0,
      low: 0,
      mid: 0,
      high: 0.1,
      text: 0,
      max: 0.25,
      lerp: 0.1
    },
    mouthFrown_R: {
      volume: 0,
      low: 0,
      mid: 0,
      high: 0.1,
      text: 0,
      max: 0.25,
      lerp: 0.1
    },
    mouthStretch_L: {
      volume: 0.04,
      low: 0,
      mid: 0.03,
      high: 0.15,
      text: 0.24,
      max: 0.2,
      lerp: 0.1
    },
    mouthStretch_R: {
      volume: 0.04,
      low: 0,
      mid: 0.03,
      high: 0.15,
      text: 0.24,
      max: 0.2,
      lerp: 0.1
    },
    mouthUpperUp_L: {
      volume: 0.06,
      low: 0.03,
      mid: 0.08,
      high: 0.03,
      text: 0.16,
      max: 0.18,
      lerp: 0.1
    },
    mouthUpperUp_R: {
      volume: 0.06,
      low: 0.03,
      mid: 0.08,
      high: 0.03,
      text: 0.16,
      max: 0.18,
      lerp: 0.1
    },
    mouthLowerDown_L: {
      volume: 0.12,
      low: 0.05,
      mid: 0.05,
      high: 0,
      text: 0.18,
      max: 0.18,
      lerp: 0.1
    },
    mouthLowerDown_R: {
      volume: 0.12,
      low: 0.05,
      mid: 0.05,
      high: 0,
      text: 0.18,
      max: 0.18,
      lerp: 0.1
    },
    mouthPress_L: {
      volume: 0.02,
      low: 0,
      mid: 0,
      high: 0.05,
      text: 0.2,
      max: 0.26,
      lerp: 0.18
    },
    mouthPress_R: {
      volume: 0.02,
      low: 0,
      mid: 0,
      high: 0.05,
      text: 0.2,
      max: 0.26,
      lerp: 0.18
    },
    mouthRollLower: {
      volume: 0.05,
      low: 0.03,
      mid: 0.06,
      high: 0,
      text: 0.06,
      max: 0.16,
      lerp: 0.12
    },
    mouthRollUpper: {
      volume: 0.04,
      low: 0,
      mid: 0.06,
      high: 0.03,
      text: 0.06,
      max: 0.16,
      lerp: 0.12
    },
    cheekSquint_L: {
      volume: 0.03,
      low: 0,
      mid: 0.12,
      high: 0.1,
      text: 0,
      max: 0.3,
      lerp: 0.08
    },
    cheekSquint_R: {
      volume: 0.03,
      low: 0,
      mid: 0.12,
      high: 0.1,
      text: 0,
      max: 0.3,
      lerp: 0.08
    },
    cheekPuff: {
      volume: 0.02,
      low: 0.05,
      mid: 0.05,
      high: 0,
      text: 0,
      max: 0.2,
      lerp: 0.08
    },
    noseSneer_L: {
      volume: 0,
      low: 0,
      mid: 0.08,
      high: 0.12,
      text: 0,
      max: 0.25,
      lerp: 0.1
    },
    noseSneer_R: {
      volume: 0,
      low: 0,
      mid: 0.08,
      high: 0.12,
      text: 0,
      max: 0.25,
      lerp: 0.1
    },
    browInnerUp: {
      volume: 0,
      low: 0,
      mid: 0.08,
      high: 0.15,
      text: 0,
      max: 0.35,
      lerp: 0.08
    },
    browDown_L: {
      volume: 0,
      low: 0,
      mid: 0.05,
      high: 0.1,
      text: 0,
      max: 0.2,
      lerp: 0.08
    },
    browDown_R: {
      volume: 0,
      low: 0,
      mid: 0.05,
      high: 0.1,
      text: 0,
      max: 0.2,
      lerp: 0.08
    },
    browOuterUp_L: {
      volume: 0,
      low: 0,
      mid: 0.05,
      high: 0.1,
      text: 0,
      max: 0.2,
      lerp: 0.08
    },
    browOuterUp_R: {
      volume: 0,
      low: 0,
      mid: 0.05,
      high: 0.1,
      text: 0,
      max: 0.2,
      lerp: 0.08
    },
    tongue_out: {
      volume: 0,
      low: 0,
      mid: 0.02,
      high: 0.03,
      text: 0.1,
      max: 0.12,
      lerp: 0.12
    }
  },
  bones: {
    jaw: {
      aliases: [
        "jaw"
      ],
      volume: 0.22,
      low: 0.16,
      mid: 0.06,
      high: 0.28,
      text: 0.05,
      maxRotX: 0.029,
      maxRotY: -0.024,
      maxRotZ: 0.085,
      maxPosX: 0.004,
      maxPosY: -0.008,
      maxPosZ: -0.064,
      lerp: 0.39
    },
    jaw_open: {
      aliases: [
        "jaw_open_lt_rt_frwd"
      ],
      volume: 0.24,
      low: 0.1,
      mid: 0.03,
      high: 0,
      text: 0.32,
      maxRotX: 0.14,
      maxRotY: 0,
      maxRotZ: 0,
      maxPosX: 0,
      maxPosY: -0.018,
      maxPosZ: 0.006,
      lerp: 0.22
    },
    jaw_down: {
      aliases: [
        "jaw_dwn_mouth_clsd"
      ],
      volume: 0.16,
      low: 0.08,
      mid: 0.02,
      high: 0,
      text: 0.2,
      maxRotX: 0.1,
      maxRotY: 0,
      maxRotZ: 0,
      maxPosX: 0,
      maxPosY: -0.012,
      maxPosZ: 0.004,
      lerp: 0.2
    },
    mouth_funnel: {
      aliases: [
        "mouth_lt_rt_funnel"
      ],
      volume: 0.03,
      low: 0.02,
      mid: 0.09,
      high: 0.04,
      text: 0.26,
      maxRotX: 0,
      maxRotY: 0.018,
      maxRotZ: 0,
      maxPosX: 0,
      maxPosY: 0,
      maxPosZ: 0.01,
      lerp: 0.16
    },
    mouth_pucker: {
      aliases: [
        "pucker_cheekPuf"
      ],
      volume: 0.02,
      low: 0.03,
      mid: 0.03,
      high: 0,
      text: 0.24,
      maxRotX: 0,
      maxRotY: 0,
      maxRotZ: 0,
      maxPosX: 0,
      maxPosY: 0.002,
      maxPosZ: 0.01,
      lerp: 0.16
    },
    mouth_shrug_upper: {
      aliases: [
        "mouth_shrug_roll_upper"
      ],
      volume: 0.04,
      low: 0,
      mid: 0.08,
      high: 0.04,
      text: 0.08,
      maxRotX: -0.02,
      maxRotY: 0,
      maxRotZ: 0,
      maxPosX: 0,
      maxPosY: 0.01,
      maxPosZ: 0,
      lerp: 0.14
    },
    mouth_roll_lower: {
      aliases: [
        "mouth_roll_lower"
      ],
      volume: 0.05,
      low: 0.04,
      mid: 0.05,
      high: 0,
      text: 0.08,
      maxRotX: 0.02,
      maxRotY: 0,
      maxRotZ: 0,
      maxPosX: 0,
      maxPosY: -0.01,
      maxPosZ: 0,
      lerp: 0.14
    },
    mouth_upper_up_L: {
      aliases: [
        "mouth_upper_up_L"
      ],
      volume: 0.06,
      low: 0,
      mid: 0.07,
      high: 0.03,
      text: 0.14,
      maxRotX: -0.014,
      maxRotY: 0,
      maxRotZ: 0,
      maxPosX: 0,
      maxPosY: 0.012,
      maxPosZ: 0.002,
      lerp: 0.14
    },
    mouth_upper_up_R: {
      aliases: [
        "mouth_upper_up_R"
      ],
      volume: 0.06,
      low: 0,
      mid: 0.07,
      high: 0.03,
      text: 0.14,
      maxRotX: -0.014,
      maxRotY: 0,
      maxRotZ: 0,
      maxPosX: 0,
      maxPosY: 0.012,
      maxPosZ: 0.002,
      lerp: 0.14
    },
    mouth_lower_down_L: {
      aliases: [
        "mouth_lower_down_L"
      ],
      volume: 0.12,
      low: 0.05,
      mid: 0.02,
      high: 0,
      text: 0.18,
      maxRotX: 0.02,
      maxRotY: 0,
      maxRotZ: 0,
      maxPosX: 0,
      maxPosY: -0.014,
      maxPosZ: 0.002,
      lerp: 0.18
    },
    mouth_lower_down_R: {
      aliases: [
        "mouth_lower_down_R"
      ],
      volume: 0.12,
      low: 0.05,
      mid: 0.02,
      high: 0,
      text: 0.18,
      maxRotX: 0.02,
      maxRotY: 0,
      maxRotZ: 0,
      maxPosX: 0,
      maxPosY: -0.014,
      maxPosZ: 0.002,
      lerp: 0.18
    },
    mouth_stretch_L: {
      aliases: [
        "mouth_stretch_L"
      ],
      volume: 0.02,
      low: 0,
      mid: 0.02,
      high: 0.12,
      text: 0.18,
      maxRotX: 0,
      maxRotY: 0,
      maxRotZ: 0.018,
      maxPosX: 0.012,
      maxPosY: 0,
      maxPosZ: 0,
      lerp: 0.15
    },
    mouth_stretch_R: {
      aliases: [
        "mouth_stretch_R"
      ],
      volume: 0.02,
      low: 0,
      mid: 0.02,
      high: 0.12,
      text: 0.18,
      maxRotX: 0,
      maxRotY: 0,
      maxRotZ: -0.018,
      maxPosX: -0.012,
      maxPosY: 0,
      maxPosZ: 0,
      lerp: 0.15
    },
    mouth_smile_frown_L: {
      aliases: [
        "mouth_smile_frown_L"
      ],
      volume: 0,
      low: 0,
      mid: 0.1,
      high: 0.05,
      text: 0,
      maxRotX: 0,
      maxRotY: 0,
      maxRotZ: 0,
      maxPosX: 0,
      maxPosY: 0.018,
      maxPosZ: 0,
      lerp: 0.1
    },
    mouth_smile_frown_R: {
      aliases: [
        "mouth_smile_frown_R"
      ],
      volume: 0,
      low: 0,
      mid: 0.1,
      high: 0.05,
      text: 0,
      maxRotX: 0,
      maxRotY: 0,
      maxRotZ: 0,
      maxPosX: 0,
      maxPosY: 0.018,
      maxPosZ: 0,
      lerp: 0.1
    },
    mouth_dimple_L: {
      aliases: [
        "mouth_dimple_L"
      ],
      volume: 0,
      low: 0,
      mid: 0.08,
      high: 0.05,
      text: 0,
      maxRotX: 0,
      maxRotY: 0,
      maxRotZ: 0,
      maxPosX: 0.005,
      maxPosY: 0.005,
      maxPosZ: 0,
      lerp: 0.1
    },
    mouth_dimple_R: {
      aliases: [
        "mouth_dimple_R"
      ],
      volume: 0,
      low: 0,
      mid: 0.08,
      high: 0.05,
      text: 0,
      maxRotX: 0,
      maxRotY: 0,
      maxRotZ: 0,
      maxPosX: -0.005,
      maxPosY: 0.005,
      maxPosZ: 0,
      lerp: 0.1
    },
    nose_sneer_L: {
      aliases: [
        "nose_sneer_L"
      ],
      volume: 0,
      low: 0,
      mid: 0.06,
      high: 0.1,
      text: 0,
      maxRotX: 0,
      maxRotY: 0,
      maxRotZ: 0,
      maxPosX: 0,
      maxPosY: 0.008,
      maxPosZ: 0.005,
      lerp: 0.1
    },
    nose_sneer_R: {
      aliases: [
        "nose_sneer_R"
      ],
      volume: 0,
      low: 0,
      mid: 0.06,
      high: 0.1,
      text: 0,
      maxRotX: 0,
      maxRotY: 0,
      maxRotZ: 0,
      maxPosX: 0,
      maxPosY: 0.008,
      maxPosZ: 0.005,
      lerp: 0.1
    },
    cheek_squint_L: {
      aliases: [
        "cheek_squint_L"
      ],
      volume: 0.02,
      low: 0,
      mid: 0.1,
      high: 0.08,
      text: 0,
      maxRotX: 0,
      maxRotY: 0,
      maxRotZ: 0,
      maxPosX: 0,
      maxPosY: 0.005,
      maxPosZ: 0.008,
      lerp: 0.08
    },
    cheek_squint_R: {
      aliases: [
        "cheek_squint_R"
      ],
      volume: 0.02,
      low: 0,
      mid: 0.1,
      high: 0.08,
      text: 0,
      maxRotX: 0,
      maxRotY: 0,
      maxRotZ: 0,
      maxPosX: 0,
      maxPosY: 0.005,
      maxPosZ: 0.008,
      lerp: 0.08
    },
    brow_inner_up: {
      aliases: [
        "brow_inner_up"
      ],
      volume: 0,
      low: 0.62,
      mid: 0.56,
      high: 0.53,
      text: 0,
      maxRotX: 0.088,
      maxRotY: 0,
      maxRotZ: 0,
      maxPosX: 0,
      maxPosY: 0.025,
      maxPosZ: 0,
      lerp: 0.08
    },
    brow_dwn_L: {
      aliases: [
        "brow_dwn_L"
      ],
      volume: 0,
      low: 0,
      mid: 0.04,
      high: 0.08,
      text: 0,
      maxRotX: 0.06,
      maxRotY: 0,
      maxRotZ: 0,
      maxPosX: 0,
      maxPosY: -0.005,
      maxPosZ: 0,
      lerp: 0.08
    },
    brow_dwn_R: {
      aliases: [
        "brow_dwn_R"
      ],
      volume: 0,
      low: 0,
      mid: 0.04,
      high: 0.08,
      text: 0,
      maxRotX: 0.06,
      maxRotY: 0,
      maxRotZ: 0,
      maxPosX: 0,
      maxPosY: -0.005,
      maxPosZ: 0,
      lerp: 0.08
    },
    eye_squint_L: {
      aliases: [
        "eye_squint_L"
      ],
      volume: 0,
      low: 0,
      mid: 0.05,
      high: 0.15,
      text: 0,
      maxRotX: 0,
      maxRotY: 0,
      maxRotZ: 0,
      maxPosX: 0,
      maxPosY: 0.003,
      maxPosZ: 0.005,
      lerp: 0.08
    },
    eye_squint_R: {
      aliases: [
        "eye_squint_R"
      ],
      volume: 0,
      low: 0,
      mid: 0.05,
      high: 0.15,
      text: 0,
      maxRotX: 0,
      maxRotY: 0,
      maxRotZ: 0,
      maxPosX: 0,
      maxPosY: 0.003,
      maxPosZ: 0.005,
      lerp: 0.08
    },
    tongue: {
      aliases: [
        "tongue_out_lt_rt_up_dwn"
      ],
      volume: 0,
      low: 0,
      mid: 0.02,
      high: 0.04,
      text: 0.12,
      maxRotX: 0.018,
      maxRotY: 0,
      maxRotZ: 0,
      maxPosX: 0,
      maxPosY: 0,
      maxPosZ: 0.006,
      lerp: 0.12
    },
    brow_outer_up_L: {
      low: 0,
      mid: 0.04,
      high: 0.1,
      maxRotX: 0,
      maxRotY: 0,
      maxRotZ: 0,
      maxPosX: 0,
      maxPosY: 0.015,
      maxPosZ: 0,
      lerp: 0.08
    },
    brow_outer_up_R: {
      low: 0,
      mid: 0.04,
      high: 0.1,
      maxRotX: 0,
      maxRotY: 0,
      maxRotZ: 0,
      maxPosX: 0,
      maxPosY: 0.015,
      maxPosZ: 0,
      lerp: 0.08
    }
  },
  global: {
    smoothing: 0.24,
    attack: 0.48,
    release: 0.44,
    powerCurve: 1.4,
    normalizeDivisor: 237,
    noiseFloor: 8,
    textInfluence: 0.04
  }
}
;

export function loadLipSyncConfig() {
  try {
    const saved = localStorage.getItem('three-gpt-lipsync-config');
    if (saved) {
      const parsed = JSON.parse(saved);
      return deepMerge(defaultLipSyncConfig, parsed);
    }
  } catch (e) {
    console.warn('Failed to load lip-sync config from localStorage:', e);
  }
  return JSON.parse(JSON.stringify(defaultLipSyncConfig));
}

export function saveLipSyncConfig(config) {
  try {
    localStorage.setItem('three-gpt-lipsync-config', JSON.stringify(config));
  } catch (e) {
    console.warn('Failed to save lip-sync config:', e);
  }
}

export function resetLipSyncConfig() {
  localStorage.removeItem('three-gpt-lipsync-config');
  return JSON.parse(JSON.stringify(defaultLipSyncConfig));
}

function deepMerge(defaults, overrides) {
  const result = JSON.parse(JSON.stringify(defaults));
  for (const key of Object.keys(overrides || {})) {
    if (key === 'morphTargets' || key === 'bones') {
      for (const targetKey of Object.keys(overrides[key] || {})) {
        if (result[key][targetKey]) {
          result[key][targetKey] = { ...result[key][targetKey], ...overrides[key][targetKey] };
        } else {
          result[key][targetKey] = overrides[key][targetKey];
        }
      }
    } else if (typeof overrides[key] === 'object' && overrides[key] !== null && !Array.isArray(overrides[key])) {
      result[key] = { ...result[key], ...overrides[key] };
    } else {
      result[key] = overrides[key];
    }
  }
  return result;
}
